// extracted by mini-css-extract-plugin
export default {"container":"Container_container__To9l+","header":"Container_header__ye1LJ","content":"Container_content__PD4I9"};